import { useMutation, UseMutationResult } from "@tanstack/react-query";
import { enum_api_uri } from "../utils/enum";
import axiosInstance from "./axiosInstanse";

interface Request {
    c_code: string;
    c_branch: string | undefined;
    s_kind: string;
    s_pay_kind: string;
    s_cnt: string;
    s_weight: string;
    s_pay_company_code: string;
    s_pay_company: string;
    s_pay_tel: string;
    s_pay_name: string;
    s_pay_post: string;
    s_pay_address: string;
    s_pay_address_detail: string;
    a_company: string;
    a_tel: string;
    a_part: string;
    a_part_sn: string;
    a_name: string;
    a_request: string;
    a_request2: string;
    f_c_code: string;
    f_company: string;
    f_tel: string;
    f_name: string;
    f_mobile: string;
    f_post: string;
    f_address: string;
    f_address_detail: string;
    f_dam_code: string;
    t_c_code: string;
    t_company: string;
    t_tel: string;
    t_name: string;
    t_mobile: string;
    t_post: string;
    t_address: string;
    t_address_detail: string;
    bl_cnt: string;
}

interface Response {
    data: ResponseItem[];
}
type ResponseItem = {
    s_bl_no: string;
    o_kind: string;
    s_qty: number;
    s_pickup: string;
    accept_date: string;
    accept_num: string;
    accept_seq: number;
};

export const usePostPrintAdvance = (successCallback?: () => void): UseMutationResult<Response, Error, Request, unknown> => {
    return useMutation<Response, Error, Request>({
        mutationFn: async (data: Request) => {
            const response = await axiosInstance.post(enum_api_uri.post_print_advance, {
                c_code: data.c_code,
                c_branch: data.c_branch,
                s_kind: data.s_kind,
                s_pay_kind: data.s_pay_kind,
                s_cnt: data.s_cnt,
                s_weight: data.s_weight,
                s_pay_company_code: data.s_pay_company_code,
                s_pay_company: data.s_pay_company,
                s_pay_tel: data.s_pay_tel,
                s_pay_name: data.s_pay_name,
                s_pay_post: data.s_pay_post,
                s_pay_address: data.s_pay_address,
                s_pay_address_detail: data.s_pay_address_detail,
                a_company: data.a_company,
                a_tel: data.a_tel,
                a_part: data.a_part,
                a_part_sn: data.a_part_sn,
                a_name: data.a_name,
                a_request: data.a_request,
                a_request2: data.a_request2,
                f_c_code: data.f_c_code,
                f_company: data.f_company,
                f_tel: data.f_tel,
                f_name: data.f_name,
                f_mobile: data.f_mobile,
                f_post: data.f_post,
                f_address: data.f_address,
                f_address_detail: data.f_address_detail,
                f_dam_code: data.f_dam_code,
                t_c_code: data.t_c_code,
                t_company: data.t_company,
                t_tel: data.t_tel,
                t_name: data.t_name,
                t_mobile: data.t_mobile,
                t_post: data.t_post,
                t_address: data.t_address,
                t_address_detail: data.t_address_detail,
                bl_cnt: data.bl_cnt,
            });
            return response.data;
        },
        onSuccess: data => {
            successCallback?.();
        },
    });
};
